<template>
  <Card class="message-card">
    <Row type="flex">
      <i-col  :xs="24" :md="4" class="pos-relative">
        <div class="img-con v-centered text-center">
          <Avatar v-if="message.user && message.user[0].avatar" :src="message.user[0].avatar" />
          <Avatar v-else icon="ios-person" />
        </div>
      </i-col>
      <i-col  :xs="24" :md="14">
        <p class="ellipsis" :style="(unreadCount.unread_message_count)?'font-weight:bold':''" v-if="message.user[0].industry"> Anonymous ({{ message.user[0].industry }})</p>
        <p class="ellipsis" :style="(unreadCount.unread_message_count)?'font-weight:bold':''" v-else> {{ message.user[0].username }}</p>
        <p class="ellipsis" style="color:#2b85e4;width:fit-content" @click="handleTechProviderPage(company.company_slug)"> {{ company.company_name }}</p>
        <p style="color:#999">{{ message.rfp_number }}</p>
      </i-col>
      <i-col  :xs="24" :md="6" class="pos-relative text-right">
        <small>{{ unreadCount.timestamp | null }}</small>
        <p class="text-center" v-if="unreadCount && unreadCount.unread_message_count && active.company.company_id != company.company_id"><small><Badge :count="unreadCount.unread_message_count"></Badge></small></p>
      </i-col>
    </Row>
  </Card>
</template>

<script>
import { unreadMessagesCount } from '@/services/rfps-messages'

export default {
  props: {
    message: {
      type: Object,
      default: () => {}
    },
    company: {
      type: Object,
      default: () => {}
    },
    active: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      backendBaseUrl: process.env.VUE_APP_URL,
      unreadMessagesCount: {}
    }
  },

  computed: {
    unreadCount () {
      return this.unreadMessagesCount
    }
  },

  methods: {
    handleTechProviderPage (slug) {
      const routeData = this.$router.resolve({
        name: 'company',
        params: {
          slug: slug
        },
        query: {}
      })
      window.open(routeData.href, '_blank')
    },
    getUnreadMessagesCount () {
      unreadMessagesCount(this.message.id, this.company.company_id).then(res => {
        this.unreadMessagesCount = res.data[0]
      }).catch(err => {
        console.log('Failed to get unread messages count: ', err)
        this.unreadMessagesCount = {}
      })
    }
  },

  mounted () {
    this.getUnreadMessagesCount()
  }
}
</script>

<style lang="scss">
.message-card {
  box-shadow: 0px 1px 3px #00000029;
  border-radius: 5px;
  overflow: hidden;
  .img-con {
    border-radius: 50%;
    overflow: hidden;
    background: #ffffff;
    width: 30px;
    height: 30px;
  }
}
</style>
